import { FEATURE, FEATURE_FLAG, INFLUENCERS } from '../constants/features';
import { EMPTY } from '../constants';

import { reduce } from './iterable/reduce';

function isWhitelisted({ userId, users }) {
  switch (users) {
    case 'all': {
      return true;
    }

    case 'none': {
      return false;
    }

    default: {
      return users.has(userId);
    }
  }
}

function isFeatureEnabled({ feature, userId }) {
  switch (feature) {
    case FEATURE.ACTIVATE_SHOP: {
      return (
        FEATURE_FLAG.ACTIVATE_SHOP_ENABLED &&
        isWhitelisted({ userId, users: FEATURE_FLAG.ACTIVATE_SHOP_USERS })
      );
    }

    case FEATURE.AI_COPY: {
      return (
        FEATURE_FLAG.AI_COPY_ENABLED &&
        isWhitelisted({ userId, users: FEATURE_FLAG.AI_COPY_USERS })
      );
    }

    case FEATURE.AI_PROFILES: {
      return (
        isFeatureEnabled({ feature: FEATURE.AI_V2, userId }) &&
        FEATURE_FLAG.AI_PROFILES_ENABLED &&
        isWhitelisted({ userId, users: FEATURE_FLAG.AI_PROFILES_USERS })
      );
    }

    case FEATURE.AI_V2: {
      return (
        FEATURE_FLAG.AI_V2_ENABLED &&
        isWhitelisted({ userId, users: FEATURE_FLAG.AI_V2_USERS })
      );
    }

    case FEATURE.BILLING_V3: {
      return (
        FEATURE_FLAG.BILLING_V3_ENABLED &&
        isWhitelisted({ userId, users: FEATURE_FLAG.BILLING_V3_USERS })
      );
    }

    case FEATURE.FAIRE_INTEGRATION: {
      return (
        FEATURE_FLAG.FAIRE_INTEGRATION_ENABLED &&
        isWhitelisted({ userId, users: FEATURE_FLAG.FAIRE_INTEGRATION_USERS })
      );
    }

    case FEATURE.HELP_CENTER: {
      return (
        FEATURE_FLAG.HELP_CENTER_ENABLED &&
        isWhitelisted({ userId, users: FEATURE_FLAG.HELP_CENTER_USERS })
      );
    }

    case FEATURE.IMAGE_GROUPING: {
      return (
        FEATURE_FLAG.IMAGE_GROUPING_ENABLED &&
        isWhitelisted({ userId, users: FEATURE_FLAG.IMAGE_GROUPING_USERS })
      );
    }

    case FEATURE.LISTING_SCORE: {
      return (
        FEATURE_FLAG.LISTING_SCORE_ENABLED &&
        isWhitelisted({ userId, users: FEATURE_FLAG.LISTING_SCORE_USERS }) &&
        isFeatureEnabled({ feature: FEATURE.AI_V2, userId })
      );
    }

    case FEATURE.MERGE_LISTINGS: {
      return (
        FEATURE_FLAG.MERGE_LISTINGS_ENABLED &&
        isWhitelisted({ userId, users: FEATURE_FLAG.MERGE_LISTINGS_USERS })
      );
    }

    case FEATURE.PHOTO_CONTROLS: {
      return (
        FEATURE_FLAG.PHOTO_CONTROLS_ENABLED &&
        isWhitelisted({ userId, users: FEATURE_FLAG.PHOTO_CONTROLS_USERS })
      );
    }

    case FEATURE.PHOTO_EDITOR_LAYERS: {
      return (
        FEATURE_FLAG.PHOTO_EDITOR_LAYERS_ENABLED &&
        isWhitelisted({ userId, users: FEATURE_FLAG.PHOTO_EDITOR_LAYERS_USERS })
      );
    }

    case FEATURE.PROCESSING_PROFILES: {
      return (
        FEATURE_FLAG.PROCESSING_PROFILES_ENABLED &&
        isWhitelisted({ userId, users: FEATURE_FLAG.PROCESSING_PROFILES_USERS })
      );
    }

    case FEATURE.REDESIGN: {
      return (
        FEATURE_FLAG.REDESIGN_ENABLED &&
        isWhitelisted({ userId, users: FEATURE_FLAG.REDESIGN_USERS })
      );
    }

    case FEATURE.STAGING_STATUS: {
      return (
        FEATURE_FLAG.STAGING_STATUS_ENABLED &&
        isWhitelisted({ userId, users: FEATURE_FLAG.STAGING_STATUS_USERS })
      );
    }

    case FEATURE.STUDIO_V2: {
      return (
        FEATURE_FLAG.STUDIO_V2_ENABLED &&
        isWhitelisted({ userId, users: FEATURE_FLAG.STUDIO_V2_USERS })
      );
    }

    case FEATURE.TEMPLATE_MODE_PROFILES: {
      return (
        FEATURE_FLAG.TEMPLATE_MODE_PROFILES_ENABLED &&
        isWhitelisted({ userId, users: FEATURE_FLAG.TEMPLATE_MODE_PROFILES_USERS })
      );
    }

    case FEATURE.STUDIO_AI_EDIT: {
      return (
        FEATURE_FLAG.STUDIO_AI_EDIT_ENABLED &&
        isWhitelisted({ userId, users: FEATURE_FLAG.STUDIO_AI_EDIT_USERS })
      );
    }

    case FEATURE.AI_STRATEGY_SUPPORT: {
      return (
        FEATURE_FLAG.AI_STRATEGY_SUPPORT_ENABLED &&
        isWhitelisted({ userId, users: FEATURE_FLAG.AI_STRATEGY_SUPPORT_USERS })
      );
    }

    case FEATURE.PUBLIC_ERRORS: {
      return (
        FEATURE_FLAG.PUBLIC_ERRORS_ENABLED &&
        isWhitelisted({ userId, users: FEATURE_FLAG.PUBLIC_ERRORS_USERS })
      );
    }

    default: {
      return false;
    }
  }
}

export function getUserFeatures(userId) {
  function reduceFeatures(result, feature) {
    return result.set(feature, isFeatureEnabled({ feature, userId }));
  }

  return reduce(FEATURE, EMPTY.MAP, reduceFeatures);
}

export function isInfluencer(userId) {
  return isWhitelisted({ userId, users: INFLUENCERS });
}
